webpackJsonp([35783957827783],{

/***/ 87:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 179:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = "Hey there, visitor. \n\nWe are headless.\nWe are a creative agency.\nWe work from a lot of different places.\nWe work remote.\nBut also together.\n\nWe are creators.\nWe are conceptors.\nWe are marketeers.\nWe are creatives.\nWe are developers.\nWe are project managers.\n\nWe are everyone.\nBut also no one.\n\nWe match the people you need.\n\nWe are a team.\nCombined for your project.\nDesigned together to create your dream.\n\nWe are dream realizers.\nWe are innovators.\nWe are warriors. And superheroes. And unicorns.\n\nWe bring freelancers together to build digital bridges.\nTo build connections. \nTo increase your business.\n\nWe love you.\n\nBut there is a little problem.\nAt the moment Headless is not a we.\n              Headless is just an I.\n              Headless is just a concept idea of me, Wietse Neven\n\nI am a creative developer.\nI want to make Headless Agency a reality.\n\nDo you want to create a Headless reality together with me?\n\nPlease send me an e-mail:\n  hello@wietseneven.com\n\nOr call me:\n  +31 (0)6 - 30 70 64 30\n\nLet's create cool stuff together.\nCiao.";
	module.exports = exports["default"];

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(135);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _indexModule = __webpack_require__(264);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _home = __webpack_require__(179);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage(props) {
	    _classCallCheck(this, IndexPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      content: ''
	    };
	
	    _this.index = 0;
	    _this.done = '';
	    return _this;
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      _this2.showText(200);
	    }, 1500);
	  };
	
	  IndexPage.prototype.showText = function showText(interval) {
	    var _this3 = this;
	
	    if (this.index < _home2.default.length) {
	      this.done += _home2.default[this.index++];
	      this.setState({ content: this.done });
	
	      setTimeout(function () {
	        var delay = _home2.default[_this3.index + 1] === "\n" ? Math.random() * 2000 : Math.random() * 100;
	        _this3.showText(delay);
	      }, interval);
	    }
	  };
	
	  IndexPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'pre',
	        { className: _indexModule2.default.content },
	        this.state.content
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"src-pages----index-module---content---30-nr","blink":"src-pages----index-module---blink---1eg83"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-057eec5708cc9e570b91.js